import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { BrowserRouter } from 'react-router-dom';
import { oidcConfig } from '@/auth/auth-config';
import VersionPage from '@/pages/Version';
import AppShell from './AppShell';
import '@styles/global.css';
const rootEl = document.getElementById('root');
if (!rootEl) {
    throw new Error('#root element not found');
}
// Диагностическая страница версий — рендерим ДО AuthProvider/бутстрапа, чтобы её можно
// было открыть всегда (в т.ч. когда приложение сломано и не логинится).
if (window.location.pathname === '/version') {
    createRoot(rootEl).render(_jsx(React.StrictMode, { children: _jsx(VersionPage, {}) }));
}
else {
    createRoot(rootEl).render(_jsx(React.StrictMode, { children: _jsx(AuthProvider, { ...oidcConfig, onSigninCallback: () => {
                window.history.replaceState({}, '', '/app');
            }, children: _jsx(BrowserRouter, { children: _jsx(AppShell, {}) }) }) }));
}
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js');
    });
}
